(() => {
  let mobileMenuId = 0;

  const normalizeMobileMenuIds = (root = document) => {
    if (root.matches?.('[id="menu-level-1"]')) {
      mobileMenuId += 1;
      root.id = `toku-mobile-menu-level-1-${mobileMenuId}`;
    }

    root.querySelectorAll('[id="menu-level-1"]').forEach((menu) => {
      mobileMenuId += 1;
      menu.id = `toku-mobile-menu-level-1-${mobileMenuId}`;
    });
  };

  const start = () => {
    normalizeMobileMenuIds();

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            normalizeMobileMenuIds(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    normalizeMobileMenuIds(event.target);
  });
})();
